import { BaseWebComponentView } from '../../../../../../framework/BaseWebComponentView';
import { API_TYPE_POLICY_FILTER, WEB_COMPONENT_GRID_VIEW } from '../../../../../../webcomponents.constants';
import { ColumnDetails, ColumnType } from '../../../../../../grid/types/common';
import { TargetsColumn, TargetsColumnKeys } from '../types';
import { translateFn } from '../../../../../../utils/translator.helper';
import { enforceRenderer, inheritedFromRenderer, nameRenderer, policyRenderer } from './targetsGridRenderers';
import { TargetsGridDataProvider } from '../dataProvider/TargetsGridDataProvider';
import { dataGridStrings } from '../../../../../../grid/utils/gridStrings';
import { GridFiltersHelper } from '../../../../../../grid/gridFilters/helpers/GridFiltersHelper';

export class TargetsGridView extends BaseWebComponentView {
  getDomElements() {
    this.dom.$grid = this.shadow.querySelector(WEB_COMPONENT_GRID_VIEW);
    this.dom.$wrapper = this.shadow.querySelector('.wrapper');

    if (this.dom.$grid.injectDependencies) {
      this.dom.$grid.injectDependencies(this.dependencies);
      this.dom.$grid.start().then().catch(console.error);
    }
  }

  buildView(data: any) {
    const columnDetails: Array<ColumnDetails<TargetsColumn, TargetsColumnKeys>> = [
      {
        key: TargetsColumnKeys.NAME,
        column: TargetsColumn.NAME,
        columnName: translateFn('Entity name'),
        type: ColumnType.STRING,
        removable: false,
        sortable: true,
      },
      {
        key: TargetsColumnKeys.POLICY,
        column: TargetsColumn.POLICY,
        columnName: translateFn('Current policy'),
        type: ColumnType.BACKEND_SINGLE_SELECT,
        removable: false,
        sortable: true,
      },
      {
        key: TargetsColumnKeys.INHERITED_FROM,
        column: TargetsColumn.INHERITED_FROM,
        columnName: translateFn('Inherited from'),
        type: ColumnType.STRING,
        removable: false,
        filteringDisabled: true,
        sortable: true,
      },
      {
        key: TargetsColumnKeys.ENFORCED,
        column: TargetsColumn.ENFORCED,
        columnName: translateFn('Enforcement status'),
        type: ColumnType.STRING,
        removable: false,
        filteringDisabled: true,
        sortable: false,
      },
    ];

    this.dom.$grid.propertiesSet = false;
    this.dom.$grid.allColumnDetails = columnDetails;
    this.dom.$grid.columnRenderers = {
      [TargetsColumnKeys.NAME]: nameRenderer,
      [TargetsColumnKeys.POLICY]: policyRenderer,
      [TargetsColumnKeys.INHERITED_FROM]: inheritedFromRenderer,
      [TargetsColumnKeys.ENFORCED]: enforceRenderer,
    };
    this.dom.$grid.dataProvider = new TargetsGridDataProvider();
    this.dom.$grid.dataProvider.injectDependencies(this.dependencies);
    this.dom.$grid.hideHeaderActions = true;
    this.dom.$grid.hideFiltersToggle = true;
    this.dom.$grid.hasPagination = true;
    this.dom.$grid.shouldLoadAsync = true;
    this.dom.$grid.isCompactViewChecked = false;
    this.dom.$grid.dynamicHeight = true;
    this.dom.$grid.viewId = 'targets-grid-view-id';
    this.dom.$grid.columns = [
      TargetsColumn.NAME,
      TargetsColumn.POLICY,
      TargetsColumn.INHERITED_FROM,
      TargetsColumn.ENFORCED,
    ];
    this.dom.$grid.columnConfigs = [
      {
        key: TargetsColumnKeys.NAME,
        width: '220px',
      },
      {
        key: TargetsColumnKeys.POLICY,
        width: '220px',
      },
      {
        key: TargetsColumnKeys.INHERITED_FROM,
        width: '160px',
      },
    ];
    this.dom.$grid.defaultFlexGrowColumn = TargetsColumn.ENFORCED;
    this.dom.$grid.predefinedFiltersKeys = [TargetsColumnKeys.NAME, TargetsColumnKeys.POLICY];
    this.dom.$grid.filters = [
      {
        [TargetsColumnKeys.NAME]: { contains: '' },
      },
      {
        [TargetsColumnKeys.POLICY]: { equals: null },
      },
    ];
    this.dom.$grid.filtersUiConfigs = [
      {
        key: TargetsColumnKeys.NAME,
        config: {
          placeholder: translateFn('Search entities'),
        },
      },
      {
        key: TargetsColumnKeys.POLICY,
        config: {
          placeholder: translateFn('Select policy'),
          apiType: API_TYPE_POLICY_FILTER,
          canDelete: true,
          populateFilterCallback: GridFiltersHelper.populateFilterCallback,
        },
      },
    ];
    this.dom.$grid.customStrings = {
      noSearchResultsString: translateFn('No entities'),
      dataLoadingFailed: dataGridStrings().dataLoadingFailed,
    };
    this.dom.$grid.hideResetFilters = true;
    this.dom.$grid.isCompactViewChecked = false;
    this.dom.$grid.pageSize = 20;
    this.dom.$grid.propertiesSet = true;
  }

  clearWrapper() {
    this.dom.$wrapper.innerHTML = '';
  }
}
